import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/lib/api";

const DEFAULT_CFG = { comune_name: "Comune", ai_vision_enabled: false, ai_min_confidence: 0.75, waste_types_enabled: ["carta","plastica","vetro","metallo","umido","indifferenziato","ingombranti","legno","raee"], ream_layout: { columns: 2, rows: 4, header_mm: 30, footer_mm: 15 } };
const ConfigContext = createContext(DEFAULT_CFG);

export function ConfigProvider({ children }) {
  const [cfg, setCfg] = useState(DEFAULT_CFG);
  useEffect(() => {
    axios.get(`${API}/config`).then((r) => setCfg({ ...DEFAULT_CFG, ...r.data })).catch(() => {});
  }, []);
  return <ConfigContext.Provider value={cfg}>{children}</ConfigContext.Provider>;
}

export const useConfig = () => useContext(ConfigContext);
